import React, {useCallback} from 'react'
import {useIntl} from "react-intl";

export default function Translation(data) {
    const intl = useIntl();
    return(intl.formatMessage({ id: data.text}))
}
